import { AfterViewInit, Directive, DoCheck, ElementRef, forwardRef, HostBinding, Injector, Input, OnChanges, OnDestroy, Optional, Renderer2, Self } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgControl, Validator } from '@angular/forms';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { dataPeriodo, erroPeriodoConsulta, limitePeriodo } from '../tools/periodo-consulta';

@Directive({
  selector: 'input[appPeriodoFinal]', standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => PeriodoFinalDirective), multi: true }]
})
export class PeriodoFinalDirective implements Validator, OnChanges, AfterViewInit, DoCheck, OnDestroy {
  @Input() appPeriodoFinal: any;
  @Input() appPeriodoBloqueado = false;
  private controle: NgControl;
  private aviso: HTMLElement;
  private ultimoInicio: string;
  private destruido = false;
  private validarNovamente = () => {};
  @HostBinding('disabled') get bloqueado() { return !dataPeriodo(this.appPeriodoFinal) || this.appPeriodoBloqueado || !!this.controle?.disabled; }
  constructor(private elemento: ElementRef<HTMLInputElement>, private renderer: Renderer2, private injector: Injector,
    @Optional() @Self() private calendario: NgbInputDatepicker) {}
  ngAfterViewInit() {
    this.controle = this.injector.get(NgControl, null, { self: true });
    this.aviso = this.renderer.createElement('small');
    this.renderer.setAttribute(this.aviso, 'role', 'status');
    this.renderer.setStyle(this.aviso, 'display', 'block');
    this.renderer.setStyle(this.aviso, 'color', '#6c757d');
    this.renderer.appendChild(this.elemento.nativeElement.parentNode, this.aviso);
    this.atualizar();
  }
  ngOnChanges() { this.atualizar(); }
  private atualizar() {
    queueMicrotask(() => {
      if (this.destruido) return;
      const inicio = dataPeriodo(this.appPeriodoFinal);
      const final = this.controle?.control?.value;
      // Ao trocar/apagar a inicial, nunca mantem uma final fora do intervalo.
      if (final && (!inicio || erroPeriodoConsulta(inicio, final))) this.controle?.control?.setValue(null);
      this.validarNovamente();
    });
  }
  ngDoCheck() {
    const inicio = dataPeriodo(this.appPeriodoFinal), limite = limitePeriodo(inicio);
    if (this.calendario) {
      if (this.ultimoInicio !== inicio) this.calendario.close();
      this.ultimoInicio = inicio;
      const ngb = (iso: string) => iso ? { year: +iso.slice(0, 4), month: +iso.slice(5, 7), day: +iso.slice(8, 10) } : undefined;
      this.calendario.minDate = ngb(inicio);
      this.calendario.maxDate = ngb(limite);
      this.calendario.disabled = this.bloqueado;
    } else {
      if (inicio) this.renderer.setAttribute(this.elemento.nativeElement, 'min', inicio);
      else this.renderer.removeAttribute(this.elemento.nativeElement, 'min');
      if (limite) this.renderer.setAttribute(this.elemento.nativeElement, 'max', limite);
      else this.renderer.removeAttribute(this.elemento.nativeElement, 'max');
    }
    if (this.aviso) {
      const erro = this.controle?.control?.value ? erroPeriodoConsulta(this.appPeriodoFinal, this.controle.control.value) : '';
      this.renderer.setProperty(this.aviso, 'textContent', !inicio ? 'Selecione a data inicial primeiro.' : erro);
      this.renderer.setStyle(this.aviso, 'color', erro ? '#dc3545' : '#6c757d');
    }
  }
  validate(control: AbstractControl) {
    if (!control.value) return null;
    return erroPeriodoConsulta(this.appPeriodoFinal, control.value) ? { periodoConsulta: true } : null;
  }
  registerOnValidatorChange(fn: () => void) { this.validarNovamente = fn; }
  ngOnDestroy() {
    this.destruido = true;
    if (this.aviso?.parentNode) this.renderer.removeChild(this.aviso.parentNode, this.aviso);
  }
}
